import type { MagicCommentOptions } from "../types";

/**
 * Build embed options from a `<script>` tag's `data-*` attributes.
 *
 * Returns `null` when no `data-project-id` is present, so a script tag without
 * configuration is a no-op instead of throwing.
 */
export function readScriptConfig(
  dataset: Record<string, string | undefined>,
): MagicCommentOptions | null {
  const projectId = dataset.projectId;
  if (!projectId) {
    return null;
  }

  const serverUrl = dataset.serverUrl;
  const mode =
    dataset.mode === "preview"
      ? "preview"
      : dataset.mode === "dev"
        ? "dev"
        : undefined;

  return {
    projectId,
    reviewId: dataset.reviewId,
    pageId: dataset.pageId,
    mode,
    promptForName: dataset.promptForName !== "false",
    collaboration: serverUrl
      ? { serverUrl, apiKey: dataset.apiKey }
      : undefined,
    // data-enabled="false" is the production kill switch: the widget mounts
    // nothing at all. Any other value (or absence) leaves the widget enabled.
    ui: dataset.enabled === "false" ? { enabled: false } : undefined,
  };
}
